/**
 * Forwards anyone who lands on a ₹0 gift product's own PDP to the full-size
 * product it promotes.
 *
 * The cart drawer now links gift lines straight at the parent, so this no longer
 * sits in the middle of that journey — it only catches the other ways in: a search
 * result, a shared link, browser history.
 *
 * The map comes from snippets/freebie-parent-map.liquid, which the drawer reads
 * too, so a new gift only has to be listed once.
 */
document.addEventListener('DOMContentLoaded', function () {
  var giftProductId = window.__st && __st.rid ? __st.rid : null;
  if (!giftProductId) return;

  var mapElement = document.getElementById('freebie-parent-map');
  if (!mapElement) return;

  var parents;
  try {
    parents = JSON.parse(mapElement.textContent);
  } catch (e) {
    return;
  }

  var parentHandle = parents[giftProductId];
  if (!parentHandle) return;

  // replace, not assign: the gift URL must not go into history, or Back lands on
  // it and bounces the shopper straight forward again.
  window.location.replace('/products/' + parentHandle);
});
